// const cardHeight = 122;
// const cards = document.querySelectorAll(".card");

// for (let card of cards) {
//   const description = card.querySelector(".product__description");
//   const readMore = card.querySelector(".button");
  
//   // Set the initial maxHeight for the description
//   description.style.maxHeight = `${cardHeight}px`;
  
//   // Check if the description height exceeds the card height and hide the button if it doesn't
//   if (description.scrollHeight <= cardHeight) {
//     readMore.style.display = "none";
//   }

//   // Event listener for toggling the description
//   readMore.addEventListener("click", () => {
//     if (description.style.maxHeight === `${cardHeight}px`) {
//       description.style.maxHeight = `${description.scrollHeight}px`;
//       readMore.innerHTML = "Read less";
//     } else {
//       description.style.maxHeight = `${cardHeight}px`;
//       readMore.innerHTML = "Read more";
//     }
//   });
// }


// ============================

var swiper = new Swiper(".col_product_list", {
slidesPerView: 3,
spaceBetween: 15,
navigation: {
nextEl: ".col_product_list_block .swiper-button-next",
prevEl: ".col_product_list_block .swiper-button-prev",
},
breakpoints: {
  320: {
    slidesPerView: 2,
    spaceBetween: 15
  },
  576: {
    slidesPerView: 3,
    spaceBetween: 15
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 15
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 15
  }
}
});